"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingClient = void 0;
exports.getProtocolInfo = getProtocolInfo;
const web3_js_1 = require("@solana/web3.js");
const anchor_1 = require("@coral-xyz/anchor");
const __1 = require("..");
const fetcher_1 = require("../fetcher");
const spl_token_1 = require("@solana/spl-token");
function validateV2Mint(usingV2, mint) {
    if (usingV2 && !mint) {
        throw new Error("Mint is required for V2 functions");
    }
}
class StakingClient {
    constructor(ctx, v2Ctx, pda, v2Pda) {
        this.ctx = ctx;
        this.v2Ctx = v2Ctx;
        this.pda = pda;
        this.v2Pda = v2Pda;
    }
    depositFund(amount_1) {
        return __awaiter(this, arguments, void 0, function* (amount, usingV2 = false, mint) {
            const context = usingV2 ? this.v2Ctx : this.ctx;
            const pda = usingV2 ? this.v2Pda : this.pda;
            // Get config data
            const config = pda.config();
            const configInfo = yield context.connection.getAccountInfo(config.key);
            if (!configInfo) {
                throw new Error("Config account not found");
            }
            let mintInfo;
            if (usingV2) {
                validateV2Mint(usingV2, mint);
                mintInfo = yield (0, spl_token_1.getMint)(context.connection, mint);
                if (!mintInfo) {
                    throw new Error("Mint not found");
                }
            }
            else {
                const configData = yield context.program.account.config.fetch(config.key);
                mintInfo = yield (0, spl_token_1.getMint)(context.connection, configData.mint);
            }
            const tx = new web3_js_1.Transaction();
            const senderATA = (0, spl_token_1.getAssociatedTokenAddressSync)(mintInfo.address, context.wallet.publicKey);
            const configATA = (0, spl_token_1.getAssociatedTokenAddressSync)(mintInfo.address, config.key, true);
            const [senderATAInfo, configATAInfo] = yield context.connection.getMultipleAccountsInfo([senderATA, configATA]);
            if (!senderATAInfo) {
                throw new Error("Sender associated token account not found");
            }
            const senderATAData = yield (0, spl_token_1.getAccount)(context.connection, senderATA);
            if ((new anchor_1.BN(senderATAData.amount.toString())).lt(amount)) {
                throw new Error("Insufficient token balance to deposit");
            }
            if (!configATAInfo) {
                tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(context.wallet.publicKey, configATA, config.key, mintInfo.address));
            }
            tx.add((0, spl_token_1.createTransferCheckedInstruction)(senderATA, mintInfo.address, configATA, this.ctx.wallet.publicKey, BigInt(amount.toString()), mintInfo.decimals));
            return tx;
        });
    }
    // Admin functions
    updateAdmin(newAdmin_1) {
        return __awaiter(this, arguments, void 0, function* (newAdmin, usingV2 = false) {
            const context = usingV2 ? this.v2Ctx : this.ctx;
            const pda = usingV2 ? this.v2Pda : this.pda;
            const config = pda.config();
            const configData = yield context.fetcher.getConfig(config.key, true, usingV2);
            if (!configData) {
                throw new Error("Config account not found");
            }
            if (context.wallet.publicKey.toBase58() !== configData.admin.toBase58()) {
                throw new Error("Unauthorized");
            }
            if (newAdmin.toBase58() === configData.admin.toBase58()) {
                throw new Error("New admin is the same as the current admin");
            }
            const tx = new web3_js_1.Transaction();
            const updateAdminIx = yield context.methods.updateAdmin({
                inputs: {
                    newAdmin,
                },
            });
            if (!updateAdminIx.ix) {
                throw new Error("Failed to create updating admin instruction");
            }
            tx.add(updateAdminIx.ix);
            return tx;
        });
    }
    withdrawFund(amount_1) {
        return __awaiter(this, arguments, void 0, function* (amount, usingV2 = false, mint) {
            const context = usingV2 ? this.v2Ctx : this.ctx;
            const pda = usingV2 ? this.v2Pda : this.pda;
            const config = pda.config();
            const configInfo = yield context.connection.getAccountInfo(config.key);
            if (!configInfo) {
                throw new Error("Config account not found");
            }
            const configData = yield context.program.account.config.fetch(config.key);
            if (context.wallet.publicKey.toBase58() !== configData.admin.toBase58()) {
                throw new Error("Unauthorized");
            }
            let mintInfo;
            if (usingV2) {
                validateV2Mint(usingV2, mint);
                mintInfo = yield (0, spl_token_1.getMint)(context.connection, mint);
                if (!mintInfo) {
                    throw new Error("Mint not found");
                }
            }
            else {
                mintInfo = yield (0, spl_token_1.getMint)(context.connection, configData.mint);
            }
            const tx = new web3_js_1.Transaction();
            const adminATA = (0, spl_token_1.getAssociatedTokenAddressSync)(mintInfo.address, context.wallet.publicKey);
            const configATA = (0, spl_token_1.getAssociatedTokenAddressSync)(mintInfo.address, config.key, true);
            const [adminATAInfo, configATAInfo] = yield context.connection.getMultipleAccountsInfo([adminATA, configATA]);
            if (!adminATAInfo) {
                tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(context.wallet.publicKey, adminATA, context.wallet.publicKey, mintInfo.address));
            }
            if (!configATAInfo) {
                throw new Error("Config associated token account not found");
            }
            const configATAData = yield (0, spl_token_1.getAccount)(context.connection, configATA);
            if ((new anchor_1.BN(configATAData.amount.toString())).lt(amount)) {
                throw new Error("Insufficient token balance to withdraw");
            }
            const withdrawFundIx = usingV2
                ? yield context.methods.withdrawFund({
                    accounts: {
                        mint: mintInfo.address,
                    },
                    inputs: {
                        amount,
                    }
                })
                : yield context.methods.withdrawFund({
                    inputs: {
                        amount,
                    },
                });
            if (!withdrawFundIx.ix) {
                throw new Error("Failed to create withdrawing fund instruction");
            }
            tx.add(withdrawFundIx.ix);
            return tx;
        });
    }
    withdrawToken(amount, mint) {
        return __awaiter(this, void 0, void 0, function* () {
            const context = this.v2Ctx;
            const pda = this.v2Pda;
            const config = pda.config();
            const treasury = pda.treasury();
            const configInfo = yield context.connection.getAccountInfo(config.key);
            if (!configInfo) {
                throw new Error("Config account not found");
            }
            const configData = yield context.program.account.config.fetch(config.key);
            if (context.wallet.publicKey.toBase58() !== configData.admin.toBase58()) {
                throw new Error("Unauthorized");
            }
            let mintInfo;
            mintInfo = yield (0, spl_token_1.getMint)(context.connection, mint);
            if (!mintInfo) {
                throw new Error("Mint not found");
            }
            const tx = new web3_js_1.Transaction();
            const adminATA = (0, spl_token_1.getAssociatedTokenAddressSync)(mintInfo.address, context.wallet.publicKey);
            const treasuryATA = (0, spl_token_1.getAssociatedTokenAddressSync)(mintInfo.address, treasury.key, true);
            const [adminATAInfo, treasuryATAInfo] = yield context.connection.getMultipleAccountsInfo([adminATA, treasuryATA]);
            if (!adminATAInfo) {
                tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(context.wallet.publicKey, adminATA, context.wallet.publicKey, mintInfo.address));
            }
            if (!treasuryATAInfo) {
                throw new Error("Treasury associated token account not found");
            }
            const treasuryATAData = yield (0, spl_token_1.getAccount)(context.connection, treasuryATA);
            if ((new anchor_1.BN(treasuryATAData.amount.toString())).lt(amount)) {
                throw new Error("Insufficient token balance to withdraw");
            }
            const withdrawTokenIx = yield context.methods.withdrawRevenue({
                accounts: {
                    mint: mintInfo.address,
                },
                inputs: {
                    amount,
                }
            });
            if (!withdrawTokenIx.ix) {
                throw new Error("Failed to create withdrawing token instruction");
            }
            tx.add(withdrawTokenIx.ix);
            return tx;
        });
    }
    updateLockupVault(index_1, apy_1, lockupDuration_1, minStakeAmount_1) {
        return __awaiter(this, arguments, void 0, function* (index, apy, lockupDuration, minStakeAmount, usingV2 = false, mint) {
            const context = usingV2 ? this.v2Ctx : this.ctx;
            const pda = usingV2 ? this.v2Pda : this.pda;
            if (apy > 10000) {
                throw new Error("Invalid APY");
            }
            validateV2Mint(usingV2, mint);
            const config = pda.config();
            const lockupVault = usingV2 ? pda.lockupVaultV2(mint, new anchor_1.BN(index)) : pda.lockupVault(new anchor_1.BN(index));
            const [configInfo, lockupVaultInfo] = yield context.connection.getMultipleAccountsInfo([config.key, lockupVault.key]);
            if (!configInfo) {
                throw new Error("Config account not found");
            }
            const configData = yield context.program.account.config.fetch(config.key);
            if (context.wallet.publicKey.toBase58() !== configData.admin.toBase58()) {
                throw new Error("Unauthorized");
            }
            if (!lockupVaultInfo) {
                throw new Error("Lockup vault is not initialized");
            }
            const tx = new web3_js_1.Transaction();
            const updateLockupVaultIx = usingV2
                ? yield context.methods.updateLockupVault({
                    accounts: {
                        mint: mint,
                        lockupVault: lockupVault.key,
                    },
                    inputs: {
                        index,
                        apy,
                        lockupDuration,
                        minStakeAmount,
                    },
                })
                : yield context.methods.updateLockupVault({
                    inputs: {
                        index,
                        apy,
                        lockupDuration,
                        minStakeAmount,
                    },
                });
            if (!updateLockupVaultIx.ix) {
                throw new Error("Failed to create updating lockup vault instruction");
            }
            tx.add(updateLockupVaultIx.ix);
            return tx;
        });
    }
    updateFlexibleVault(rewardRate_1, withdrawalDelayTime_1) {
        return __awaiter(this, arguments, void 0, function* (rewardRate, withdrawalDelayTime, usingV2 = false, mint) {
            const context = usingV2 ? this.v2Ctx : this.ctx;
            const pda = usingV2 ? this.v2Pda : this.pda;
            validateV2Mint(usingV2, mint);
            const config = pda.config();
            const flexibleVault = usingV2 ? pda.flexibleVaultV2(mint) : pda.flexibleVault();
            const [configInfo, flexibleVaultInfo] = yield context.connection.getMultipleAccountsInfo([config.key, flexibleVault.key]);
            if (!configInfo) {
                throw new Error("Config account not found");
            }
            const configData = yield context.program.account.config.fetch(config.key);
            if (context.wallet.publicKey.toBase58() !== configData.admin.toBase58()) {
                throw new Error("Unauthorized");
            }
            if (!flexibleVaultInfo) {
                throw new Error("Flexible vault is not initialized");
            }
            const tx = new web3_js_1.Transaction();
            const updateFlexibleVaultIx = usingV2
                ? yield context.methods.updateFlexibleVault({
                    accounts: {
                        mint: mint,
                    },
                    inputs: {
                        rewardRate,
                        withdrawalDelayTime,
                    },
                })
                : yield context.methods.updateFlexibleVault({
                    inputs: {
                        rewardRate,
                        withdrawalDelayTime,
                    },
                });
            if (!updateFlexibleVaultIx.ix) {
                throw new Error("Failed to create updating flexible vault instruction");
            }
            tx.add(updateFlexibleVaultIx.ix);
            return tx;
        });
    }
    initTokenVaults(mint, flexibleVaultParam, lockupVaultParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const context = this.v2Ctx;
            const pda = this.v2Pda;
            const config = pda.config();
            const configInfo = yield context.connection.getAccountInfo(config.key);
            if (!configInfo) {
                throw new Error("Config account not found");
            }
            const configData = yield context.program.account.config.fetch(config.key);
            if (context.wallet.publicKey.toBase58() !== configData.admin.toBase58()) {
                throw new Error("Unauthorized");
            }
            const mintInfo = yield (0, spl_token_1.getMint)(context.connection, mint);
            if (!mintInfo) {
                throw new Error("Mint not found");
            }
            const tx = new web3_js_1.Transaction();
            const configATA = (0, spl_token_1.getAssociatedTokenAddressSync)(mintInfo.address, config.key, true);
            const flexibleVault = pda.flexibleVaultV2(mint);
            const [configATAInfo, flexibleVaultInfo] = yield context.connection.getMultipleAccountsInfo([
                configATA,
                flexibleVault.key
            ]);
            if (!configATAInfo) {
                tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(context.wallet.publicKey, configATA, config.key, mintInfo.address));
            }
            if (flexibleVaultParam) {
                if (flexibleVaultInfo) {
                    throw new Error("Flexible vault already initialized");
                }
                const initFlexibleVaultIx = yield context.methods.initFlexibleVault({
                    accounts: {
                        admin: context.wallet.publicKey,
                        mint,
                        flexibleVault: flexibleVault.key,
                    },
                    inputs: {
                        bump: flexibleVault.bump,
                        rewardRate: flexibleVaultParam.rewardRate,
                        withdrawDelayTime: flexibleVaultParam.withdrawalDelayTime,
                    },
                });
                if (!initFlexibleVaultIx.ix) {
                    throw new Error("Failed to create initializing flexible vault instruction");
                }
                tx.add(initFlexibleVaultIx.ix);
            }
            if (lockupVaultParams.length > 0) {
                const lockupVaults = lockupVaultParams.map(param => pda.lockupVaultV2(mint, new anchor_1.BN(param.index)));
                const lockVaultsInfo = yield context.connection.getMultipleAccountsInfo(lockupVaults.map(vault => vault.key));
                for (let i = 0; i < lockupVaults.length; i++) {
                    const vault = lockupVaults[i];
                    const param = lockupVaultParams[i];
                    if (lockVaultsInfo[i]) {
                        throw new Error(`Lockup vault ${param.index} already initialized`);
                    }
                    const initLockupVaultIx = yield context.methods.initLockupVault({
                        accounts: {
                            admin: context.wallet.publicKey,
                            mint,
                            lockupVault: vault.key,
                        },
                        inputs: {
                            bump: vault.bump,
                            index: param.index,
                            apy: param.apy,
                            lockupDuration: param.lockupDuration,
                            minStakeAmount: param.minStakeAmount,
                        },
                    });
                    if (!initLockupVaultIx.ix) {
                        throw new Error("Failed to create initializing lockup vault instruction");
                    }
                    tx.add(initLockupVaultIx.ix);
                }
            }
            return tx;
        });
    }
    // User functions
    stake(amount_1) {
        return __awaiter(this, arguments, void 0, function* (amount, usingV2 = false, mint) {
            const context = usingV2 ? this.v2Ctx : this.ctx;
            const pda = usingV2 ? this.v2Pda : this.pda;
            validateV2Mint(usingV2, mint);
            const tx = new web3_js_1.Transaction();
            const config = pda.config();
            const configData = yield context.program.account.config.fetch(config.key);
            const mintPubkey = usingV2 ? mint : configData.mint;
            const associatedConfig = (0, spl_token_1.getAssociatedTokenAddressSync)(mintPubkey, config.key, true);
            const flexibleAccount = usingV2
                ? pda.flexibleStakingAccountV2(mintPubkey, context.wallet.publicKey)
                : pda.flexibleStakingAccount(context.wallet.publicKey);
            const [associatedConfigInfo, flexibleAccountInfo] = yield context.connection.getMultipleAccountsInfo([associatedConfig, flexibleAccount.key]);
            if (usingV2 && !associatedConfigInfo) {
                tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(context.wallet.publicKey, associatedConfig, config.key, mintPubkey));
            }
            if (!flexibleAccountInfo) {
                const initFlexibleAccountIx = usingV2
                    ? yield context.methods.initFlexibleAccount({
                        accounts: {
                            user: context.wallet.publicKey,
                            mint: mint,
                        },
                        inputs: {
                            bump: flexibleAccount.bump,
                        },
                    })
                    : yield context.methods.initFlexibleAccount({
                        accounts: {
                            user: context.wallet.publicKey,
                        },
                        inputs: {
                            bump: flexibleAccount.bump,
                        },
                    });
                if (!initFlexibleAccountIx.ix) {
                    throw new Error("Failed to create initializing flexible account instruction");
                }
                tx.add(initFlexibleAccountIx.ix);
            }
            const stakeIx = usingV2
                ? yield context.methods.stake({
                    accounts: {
                        user: context.wallet.publicKey,
                        mint: mintPubkey,
                    },
                    inputs: {
                        amount,
                    },
                })
                : yield context.methods.stake({
                    accounts: {
                        user: context.wallet.publicKey,
                    },
                    inputs: {
                        amount,
                    },
                });
            if (!stakeIx.ix) {
                throw new Error("Failed to create staking instruction");
            }
            tx.add(stakeIx.ix);
            return tx;
        });
    }
    withdraw(amount_1) {
        return __awaiter(this, arguments, void 0, function* (amount, usingV2 = false, mint) {
            const context = usingV2 ? this.v2Ctx : this.ctx;
            const pda = usingV2 ? this.v2Pda : this.pda;
            const tx = new web3_js_1.Transaction();
            let withdrawIndex = new anchor_1.BN(0);
            validateV2Mint(usingV2, mint);
            const userAccount = usingV2
                ? pda.userV2(mint, context.wallet.publicKey)
                : pda.user(context.wallet.publicKey);
            const userAccountInfo = yield context.connection.getAccountInfo(userAccount.key);
            if (!userAccountInfo) {
                const initUserIx = usingV2
                    ? yield context.methods.initUser({
                        accounts: { user: context.wallet.publicKey, mint: mint },
                        inputs: { bump: userAccount.bump }
                    })
                    : yield context.methods.initUser({
                        accounts: { user: context.wallet.publicKey },
                        inputs: { bump: userAccount.bump }
                    });
                if (!initUserIx.ix) {
                    throw new Error("Failed to create initializing user instruction");
                }
                tx.add(initUserIx.ix);
            }
            else {
                withdrawIndex = new anchor_1.BN((yield context.program.account.user.fetch(userAccount.key)).latestWithdrawIndex);
            }
            const flexibleAccount = usingV2
                ? pda.flexibleStakingAccountV2(mint, context.wallet.publicKey)
                : pda.flexibleStakingAccount(context.wallet.publicKey);
            const config = pda.config();
            const withdrawPosition = usingV2
                ? pda.withdrawPositionV2(mint, context.wallet.publicKey, new anchor_1.BN(withdrawIndex))
                : pda.withdrawPosition(context.wallet.publicKey, new anchor_1.BN(withdrawIndex));
            const [configInfo, flexibleAccountInfo, withdrawPositionInfo] = yield context.connection.getMultipleAccountsInfo([config.key, flexibleAccount.key, withdrawPosition.key]);
            if (!configInfo) {
                throw new Error("Config account not found");
            }
            if (!flexibleAccountInfo) {
                throw new Error("Ensure user has staked before withdrawing");
            }
            if (withdrawPositionInfo) {
                throw new Error("Withdraw position index is already taken");
            }
            const configData = yield context.program.account.config.fetch(config.key);
            const mintPubkey = usingV2 ? mint : configData.mint;
            const userATA = (0, spl_token_1.getAssociatedTokenAddressSync)(mintPubkey, context.wallet.publicKey);
            const userATAInfo = yield context.connection.getAccountInfo(userATA);
            if (!userATAInfo) {
                tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(context.wallet.publicKey, userATA, context.wallet.publicKey, mintPubkey));
            }
            const withdrawIx = usingV2
                ? yield context.methods.withdraw({
                    accounts: {
                        user: context.wallet.publicKey,
                        withdrawPosition: withdrawPosition.key,
                        mint: mint,
                    },
                    inputs: {
                        withdrawPositionBump: withdrawPosition.bump,
                        index: withdrawIndex.toNumber(),
                        amount,
                    },
                })
                : yield context.methods.withdraw({
                    accounts: {
                        user: context.wallet.publicKey,
                    },
                    inputs: {
                        withdrawPositionBump: withdrawPosition.bump,
                        index: withdrawIndex.toNumber(),
                        amount,
                    },
                });
            if (!withdrawIx.ix) {
                throw new Error("Failed to create withdrawing instruction");
            }
            tx.add(withdrawIx.ix);
            return tx;
        });
    }
    withdrawAfterDelay(index_1) {
        return __awaiter(this, arguments, void 0, function* (index, usingV2 = false, mint) {
            const context = usingV2 ? this.v2Ctx : this.ctx;
            const pda = usingV2 ? this.v2Pda : this.pda;
            validateV2Mint(usingV2, mint);
            const tx = new web3_js_1.Transaction();
            const config = pda.config();
            const withdrawPosition = usingV2
                ? pda.withdrawPositionV2(mint, context.wallet.publicKey, new anchor_1.BN(index))
                : pda.withdrawPosition(context.wallet.publicKey, new anchor_1.BN(index));
            const [configInfo, withdrawPositionInfo] = yield context.connection.getMultipleAccountsInfo([
                config.key,
                withdrawPosition.key
            ]);
            if (!configInfo) {
                throw new Error("Config account not found");
            }
            if (!withdrawPositionInfo) {
                throw new Error("Ensure create withdraw position before getting delay amount");
            }
            const configData = yield context.program.account.config.fetch(config.key);
            const mintPubkey = usingV2 ? mint : configData.mint;
            const userATA = (0, spl_token_1.getAssociatedTokenAddressSync)(mintPubkey, context.wallet.publicKey);
            const userATAInfo = yield context.connection.getAccountInfo(userATA);
            if (!userATAInfo) {
                tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(context.wallet.publicKey, userATA, context.wallet.publicKey, mintPubkey));
            }
            const withdrawDelayIx = usingV2
                ? yield context.methods.withdrawDelay({
                    accounts: {
                        user: context.wallet.publicKey,
                        withdrawPosition: withdrawPosition.key,
                        mint: mint,
                    },
                    inputs: {
                        index,
                    },
                })
                : yield context.methods.withdrawDelay({
                    accounts: {
                        user: context.wallet.publicKey,
                    },
                    inputs: {
                        index,
                    },
                });
            if (!withdrawDelayIx.ix) {
                throw new Error("Failed to create withdrawing after delay instruction");
            }
            tx.add(withdrawDelayIx.ix);
            return tx;
        });
    }
    claim() {
        return __awaiter(this, arguments, void 0, function* (usingV2 = false, mint) {
            const context = usingV2 ? this.v2Ctx : this.ctx;
            const pda = usingV2 ? this.v2Pda : this.pda;
            validateV2Mint(usingV2, mint);
            const tx = new web3_js_1.Transaction();
            const config = pda.config();
            const configInfo = yield context.connection.getAccountInfo(config.key);
            if (!configInfo) {
                throw new Error("Config account not found");
            }
            const configData = yield context.program.account.config.fetch(config.key);
            const mintPubkey = usingV2 ? mint : configData.mint;
            const userATA = (0, spl_token_1.getAssociatedTokenAddressSync)(mintPubkey, context.wallet.publicKey);
            const userATAInfo = yield context.connection.getAccountInfo(userATA);
            if (!userATAInfo) {
                tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(context.wallet.publicKey, userATA, context.wallet.publicKey, mintPubkey));
            }
            const treasury = pda.treasury();
            const treasuryATA = (0, spl_token_1.getAssociatedTokenAddressSync)(mintPubkey, treasury.key, true);
            const flexibleAccount = usingV2
                ? pda.flexibleStakingAccountV2(mint, context.wallet.publicKey)
                : pda.flexibleStakingAccount(context.wallet.publicKey);
            const [flexibleAccountInfo, treasuryATAInfo] = yield context.connection.getMultipleAccountsInfo([
                flexibleAccount.key,
                treasuryATA
            ]);
            if (!flexibleAccountInfo) {
                throw new Error("Ensure user has staked before claiming");
            }
            if (usingV2 && !treasuryATAInfo) {
                tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(context.wallet.publicKey, treasuryATA, treasury.key, mint));
            }
            const claimIx = usingV2
                ? yield context.methods.claim({
                    accounts: {
                        user: context.wallet.publicKey,
                        mint: mint,
                    },
                })
                : yield context.methods.claim({
                    accounts: {
                        user: context.wallet.publicKey,
                    },
                });
            if (!claimIx.ix) {
                throw new Error("Failed to create claiming instruction");
            }
            tx.add(claimIx.ix);
            return tx;
        });
    }
    lockup(amount_1, vaultIndex_1) {
        return __awaiter(this, arguments, void 0, function* (amount, vaultIndex, usingV2 = false, mint) {
            const context = usingV2 ? this.v2Ctx : this.ctx;
            const pda = usingV2 ? this.v2Pda : this.pda;
            validateV2Mint(usingV2, mint);
            const tx = new web3_js_1.Transaction();
            let lockupIndex = new anchor_1.BN(0);
            const config = pda.config();
            const userAccount = usingV2
                ? pda.userV2(mint, context.wallet.publicKey)
                : pda.user(context.wallet.publicKey);
            const [configInfo, userAccountInfo] = yield context.connection.getMultipleAccountsInfo([config.key, userAccount.key]);
            if (!configInfo) {
                throw new Error("Config account not found");
            }
            if (!userAccountInfo) {
                const initUserIx = usingV2
                    ? yield context.methods.initUser({
                        accounts: { user: context.wallet.publicKey, mint: mint },
                        inputs: { bump: userAccount.bump },
                    })
                    : yield context.methods.initUser({
                        accounts: { user: context.wallet.publicKey },
                        inputs: { bump: userAccount.bump },
                    });
                if (!initUserIx.ix) {
                    throw new Error("Failed to create initializing user instruction");
                }
                tx.add(initUserIx.ix);
            }
            else {
                lockupIndex = new anchor_1.BN((yield context.program.account.user.fetch(userAccount.key)).latestLockupIndex);
            }
            const configData = yield context.program.account.config.fetch(config.key);
            const configATA = usingV2
                ? (0, spl_token_1.getAssociatedTokenAddressSync)(mint, config.key, true)
                : (0, spl_token_1.getAssociatedTokenAddressSync)(configData.mint, config.key, true);
            const userLockupStakingAccount = usingV2
                ? pda.lockupStakingAccount(context.wallet.publicKey, new anchor_1.BN(lockupIndex), new anchor_1.BN(vaultIndex), mint)
                : pda.lockupStakingAccount(context.wallet.publicKey, new anchor_1.BN(lockupIndex), new anchor_1.BN(vaultIndex));
            const [configATAInfo, userLockupStakingAccountInfo] = yield context.connection.getMultipleAccountsInfo([
                configATA,
                userLockupStakingAccount.key,
            ]);
            if (!configATAInfo) {
                tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(context.wallet.publicKey, configATA, config.key, mint));
            }
            if (userLockupStakingAccountInfo) {
                throw new Error("Lockup staking account is already initialized");
            }
            const lockUpIx = usingV2
                ? yield context.methods.lockup({
                    accounts: {
                        user: context.wallet.publicKey,
                        lockupVault: pda.lockupVaultV2(mint, new anchor_1.BN(vaultIndex)).key,
                        mint: mint,
                    },
                    inputs: {
                        userLockupStakingAccountBump: userLockupStakingAccount.bump,
                        index: lockupIndex.toNumber(),
                        vaultIndex,
                        amount,
                    },
                })
                : yield context.methods.lockup({
                    accounts: {
                        user: context.wallet.publicKey,
                    },
                    inputs: {
                        userLockupStakingAccountBump: userLockupStakingAccount.bump,
                        index: lockupIndex.toNumber(),
                        vaultIndex,
                        amount,
                    },
                });
            if (!lockUpIx.ix) {
                throw new Error("Failed to create locking up instruction");
            }
            tx.add(lockUpIx.ix);
            return tx;
        });
    }
    unlock(index_1, vaultIndex_1) {
        return __awaiter(this, arguments, void 0, function* (index, vaultIndex, usingV2 = false, mint) {
            const context = usingV2 ? this.v2Ctx : this.ctx;
            const pda = usingV2 ? this.v2Pda : this.pda;
            validateV2Mint(usingV2, mint);
            const tx = new web3_js_1.Transaction();
            const config = pda.config();
            const configInfo = yield context.connection.getAccountInfo(config.key);
            if (!configInfo) {
                throw new Error("Config account not found");
            }
            const configData = yield context.program.account.config.fetch(config.key);
            const mintPubkey = usingV2 ? mint : configData.mint;
            const userATA = (0, spl_token_1.getAssociatedTokenAddressSync)(mintPubkey, context.wallet.publicKey);
            const userATAInfo = yield context.connection.getAccountInfo(userATA);
            if (!userATAInfo) {
                tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(context.wallet.publicKey, userATA, context.wallet.publicKey, mintPubkey));
            }
            if (usingV2) {
                const treasury = this.v2Pda.treasury();
                const treasuryATA = (0, spl_token_1.getAssociatedTokenAddressSync)(mint, treasury.key, true);
                const treasuryATAInfo = yield context.connection.getAccountInfo(treasuryATA);
                if (!treasuryATAInfo) {
                    tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(context.wallet.publicKey, treasuryATA, treasury.key, mint));
                }
            }
            const unlockIx = usingV2
                ? yield context.methods.unlock({
                    accounts: {
                        user: context.wallet.publicKey,
                        mint: mint,
                    },
                    inputs: {
                        index,
                        vaultIndex,
                    },
                })
                : yield context.methods.unlock({
                    accounts: {
                        user: context.wallet.publicKey,
                    },
                    inputs: {
                        index,
                        vaultIndex,
                    },
                });
            if (!unlockIx.ix) {
                throw new Error("Failed to create unlocking instruction");
            }
            tx.add(unlockIx.ix);
            return tx;
        });
    }
    // Getter functions
    getUserFlexibleStakingInfo(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const context = filter.usingV2 ? this.v2Ctx : this.ctx;
            const pda = filter.usingV2 ? this.v2Pda : this.pda;
            const configData = yield context.program.account.config.fetch(pda.config().key);
            const flexibleStakingAccountsData = yield this.getAllUserFlexibleStakingAccount(configData.admin, filter.user || context.wallet.publicKey, filter.usingV2, filter.mint);
            if (flexibleStakingAccountsData.length === 0) {
                return {};
            }
            const flexibleVaults = filter.usingV2
                ? flexibleStakingAccountsData.map((account) => {
                    return pda.flexibleVaultV2(account.mint);
                })
                : [pda.flexibleVault()];
            const flexibleVaultsData = yield Promise.all(flexibleVaults.map((vault) => __awaiter(this, void 0, void 0, function* () {
                return context.program.account.flexibleVault.fetch(vault.key);
            })));
            const withdrawPositionsData = yield this.getAllUserWithdrawPosition(filter.user || context.wallet.publicKey, filter.usingV2, filter.withdrew, filter.mint);
            const now = Math.floor(Date.now() / 1000);
            let userFlexibleStakingInfo = {};
            flexibleVaultsData.map((vault, index) => {
                const pendingReward = this.getFlexiblePendingReward(now, vault, flexibleStakingAccountsData[index]);
                const totalFlexibleStaked = Number(BigInt(vault.totalSupply.toString()));
                const apr = calculateAPR(totalFlexibleStaked, Number(vault.rewardRate.toString()));
                if (filter.usingV2) {
                    if (withdrawPositionsData.length === 0) {
                        userFlexibleStakingInfo[vault.mint.toBase58()] = {
                            totalStakedAmount: flexibleStakingAccountsData[index].balance.toString(),
                            currentApr: apr,
                            withdrawDelayTime: vault.withdrawalDelayTime.toString(),
                            pendingReward: pendingReward.toString(),
                            unstakePending: "0",
                            redeemPending: "0",
                            withdrawPositions: [],
                        };
                    }
                    else {
                        const { unstakePending, redeemPending, withdrawPositions } = this.getFlexibleStakingInfo(filter.usingV2, now, vault, withdrawPositionsData, vault.mint);
                        userFlexibleStakingInfo[vault.mint.toBase58()] = {
                            totalStakedAmount: flexibleStakingAccountsData[index].balance.toString(),
                            currentApr: apr,
                            withdrawDelayTime: vault.withdrawalDelayTime.toString(),
                            pendingReward: pendingReward.toString(),
                            unstakePending: unstakePending.toString(),
                            redeemPending: redeemPending.toString(),
                            withdrawPositions,
                        };
                    }
                }
                else {
                    if (withdrawPositionsData.length === 0) {
                        userFlexibleStakingInfo[configData.mint.toBase58()] = {
                            totalStakedAmount: flexibleStakingAccountsData[index].balance.toString(),
                            currentApr: apr,
                            withdrawDelayTime: vault.withdrawalDelayTime.toString(),
                            pendingReward: pendingReward.toString(),
                            unstakePending: "0",
                            redeemPending: "0",
                            withdrawPositions: [],
                        };
                    }
                    else {
                        const { unstakePending, redeemPending, withdrawPositions } = this.getFlexibleStakingInfo(filter.usingV2, now, vault, withdrawPositionsData);
                        userFlexibleStakingInfo[configData.mint.toBase58()] = {
                            totalStakedAmount: flexibleStakingAccountsData[index].balance.toString(),
                            currentApr: apr,
                            withdrawDelayTime: vault.withdrawalDelayTime.toString(),
                            pendingReward: pendingReward.toString(),
                            unstakePending: unstakePending.toString(),
                            redeemPending: redeemPending.toString(),
                            withdrawPositions,
                        };
                    }
                }
            });
            return userFlexibleStakingInfo;
        });
    }
    getUserLockupStakingInfo(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const context = filter.usingV2 ? this.v2Ctx : this.ctx;
            const pda = filter.usingV2 ? this.v2Pda : this.pda;
            const configData = yield context.program.account.config.fetch(pda.config().key);
            const lockupVaultsData = yield this.getAllLockupVaultProtocol(filter.usingV2, filter.usingV2
                ? filter.mint
                : configData.mint);
            if (lockupVaultsData.length === 0) {
                return {};
            }
            let mintList = [];
            if (filter.usingV2 && !filter.mint) {
                mintList = [...new Set(lockupVaultsData.map(vault => vault.mint))];
            }
            else {
                mintList = filter.mint ? [filter.mint.toBase58()] : [configData.mint.toBase58()];
            }
            if (mintList.length === 0) {
                return {};
            }
            const lockupStakingAccounts = yield this.getAllUserLockupStakingAccount(filter.user || context.wallet.publicKey, filter.usingV2, filter.unlocked, filter.mint);
            if (lockupStakingAccounts.length === 0) {
                return {};
            }
            const userLockStakingInfo = {};
            mintList.map((mint) => {
                let totalStakedAmount = new anchor_1.BN(0);
                let maturedAmount = new anchor_1.BN(0);
                const lockupVaults = filter.usingV2
                    ? lockupVaultsData.filter((vault) => vault.mint === mint)
                    : lockupVaultsData;
                let lockupStakingAccountsByVault = [];
                lockupVaults.map((vault) => {
                    const stakingAccounts = lockupStakingAccounts.filter((account) => {
                        return account.lockupVault.toBase58() === vault.lockupVault;
                    });
                    stakingAccounts.map((account) => {
                        totalStakedAmount = totalStakedAmount.add(account.lockedAmount);
                        const maturedTime = account.lockedAt.add(new anchor_1.BN(vault.lockupDuration.toString()));
                        if (maturedTime.lte(new anchor_1.BN(Math.floor(Date.now() / 1000)))) {
                            maturedAmount = maturedAmount.add(account.lockedAmount);
                        }
                        lockupStakingAccountsByVault.push({
                            bump: account.bump,
                            index: account.index,
                            lockupVault: account.lockupVault.toBase58(),
                            lockupVaultIndex: vault.index,
                            lockupDuration: vault.lockupDuration.toString(),
                            committedApy: account.committedApy,
                            lockedAmount: account.lockedAmount.toString(),
                            lockedAt: account.lockedAt.toString(),
                            unlocked: account.unlocked,
                        });
                    });
                });
                lockupStakingAccountsByVault.sort((a, b) => a.index - b.index);
                userLockStakingInfo[mint] = {
                    totalLockedAmount: totalStakedAmount.toString(),
                    maturedAmount: maturedAmount.toString(),
                    lockupStakingAccounts: lockupStakingAccountsByVault,
                };
            });
            return userLockStakingInfo;
        });
    }
    getAllUserFlexibleStakingAccount(admin, user, usingV2, mint) {
        return __awaiter(this, void 0, void 0, function* () {
            const context = usingV2 ? this.v2Ctx : this.ctx;
            const pda = usingV2 ? this.v2Pda : this.pda;
            const filters = [
                { dataSize: usingV2 ? __1.FLEXIBLE_STAKING_ACCOUNT_LEN : __1.SOLCAT_FLEXIBLE_STAKING_ACCOUNT_LEN },
                {
                    memcmp: {
                        offset: usingV2 ? (0, __1.getFlexibleStakingAccountUserOffsetV2)() : (0, __1.getFlexibleStakingAccountUserOffset)(),
                        bytes: user.toBase58()
                    }
                }
            ];
            if (usingV2 && mint) {
                filters.push({
                    memcmp: {
                        offset: (0, __1.getFlexibleStakingAccountMintOffsetV2)(),
                        bytes: mint.toBase58()
                    }
                });
            }
            let flexibleStakingAccounts = yield context.connection.getProgramAccounts(context.program.programId, { filters });
            if (flexibleStakingAccounts.length === 0) {
                return [];
            }
            if (admin.toBase58() == user.toBase58() && !usingV2) {
                const config = pda.config().key;
                flexibleStakingAccounts = flexibleStakingAccounts.filter((account) => account.pubkey.toBase58() !== config.toBase58());
            }
            return yield Promise.all(flexibleStakingAccounts.map((account) => __awaiter(this, void 0, void 0, function* () {
                return yield context.program.account.flexibleStakingAccount
                    .fetch(account.pubkey);
            })));
        });
    }
    getAllUserWithdrawPosition(user, usingV2, withdrew, mint) {
        return __awaiter(this, void 0, void 0, function* () {
            const context = usingV2 ? this.v2Ctx : this.ctx;
            let filters = [
                { dataSize: usingV2 ? __1.WITHDRAW_POSITION_LEN : __1.SOLCAT_WITHDRAW_POSITION_LEN },
                {
                    memcmp: {
                        offset: usingV2 ? (0, __1.getWithdrawPositionUserOffsetV2)() : (0, __1.getWithdrawPositionUserOffset)(),
                        bytes: user.toBase58()
                    }
                }
            ];
            if (withdrew !== undefined) {
                filters.push({
                    memcmp: {
                        offset: usingV2 ? (0, __1.getWithdrawPositionClaimedOffsetV2)() : (0, __1.getWithdrawPositionClaimedOffset)(),
                        bytes: withdrew ? "2" : "1",
                    },
                });
            }
            if (usingV2 && mint) {
                filters.push({
                    memcmp: {
                        offset: (0, __1.getWithdrawPositionMintOffsetV2)(),
                        bytes: mint.toBase58()
                    }
                });
            }
            const withdrawPositionAccounts = yield context.connection.getProgramAccounts(context.program.programId, { filters });
            if (withdrawPositionAccounts.length === 0) {
                return [];
            }
            let withdrawPositions = [];
            yield Promise.all(withdrawPositionAccounts.map((account) => __awaiter(this, void 0, void 0, function* () {
                const data = yield context.program.account.withdrawPosition.fetch(account.pubkey);
                withdrawPositions.push(data);
            })));
            return withdrawPositions;
        });
    }
    getFlexiblePendingReward(now, vault, flexibleStakingAccount) {
        const timePassed = new anchor_1.BN(now).sub(vault.lastUpdateTime);
        let rewardPerToken = new anchor_1.BN(0);
        if (vault.totalSupply.eq(new anchor_1.BN(0))) {
            rewardPerToken = vault.rewardPerTokenStored;
        }
        else {
            rewardPerToken = vault.rewardPerTokenStored.add(vault.rewardRate
                .mul(timePassed)
                .mul(__1.SCALE_FACTOR)
                .div(vault.totalSupply));
        }
        return flexibleStakingAccount.balance
            .mul(rewardPerToken.sub(flexibleStakingAccount.userRewardPerTokenPaid))
            .div(__1.SCALE_FACTOR)
            .add(flexibleStakingAccount.reward);
    }
    getFlexibleStakingInfo(usingV2, now, vault, withdrawPositionsData, mint) {
        let unstakePending = new anchor_1.BN(0);
        let redeemPending = new anchor_1.BN(0);
        if (withdrawPositionsData.length === 0) {
            return {
                unstakePending,
                redeemPending,
                withdrawPositions: []
            };
        }
        const withdrawPositions = withdrawPositionsData
            .filter((withdrawPosition) => {
            if (usingV2 && mint) {
                return withdrawPosition.mint.toBase58() === mint.toBase58();
            }
            return true;
        }).map((withdrawPosition) => {
            const releaseTime = withdrawPosition.startDelayTime.add(vault.withdrawalDelayTime);
            if (releaseTime.lt(new anchor_1.BN(now))) {
                redeemPending = redeemPending.add(withdrawPosition.amount);
            }
            else {
                unstakePending = unstakePending.add(withdrawPosition.amount);
            }
            return usingV2
                ? {
                    mint: withdrawPosition.mint.toBase58(),
                    positionIndex: withdrawPosition.positionIndex,
                    amount: withdrawPosition.amount.toString(),
                    startDelayTime: withdrawPosition.startDelayTime.toString(),
                    unlockTime: releaseTime.toString(),
                    claimed: withdrawPosition.claimed,
                }
                : {
                    index: withdrawPosition.index,
                    amount: withdrawPosition.amount.toString(),
                    startDelayTime: withdrawPosition.startDelayTime.toString(),
                    unlockTime: releaseTime.toString(),
                    claimed: withdrawPosition.claimed,
                };
        });
        // sort withdraw positions by index
        usingV2
            ? withdrawPositions.sort((a, b) => a.positionIndex - b.positionIndex)
            : withdrawPositions.sort((a, b) => a.index - b.index);
        return {
            unstakePending,
            redeemPending,
            withdrawPositions,
        };
    }
    getAllLockupVaultProtocol(usingV2, mint) {
        return __awaiter(this, void 0, void 0, function* () {
            const context = usingV2 ? this.v2Ctx : this.ctx;
            const fetcher = new fetcher_1.AccountFetcher(context.connection);
            const lockupVaultFilter = [{
                    dataSize: usingV2 ? __1.LOCKUP_VAULT_LEN : __1.SOLCAT_LOCKUP_VAULT_LEN
                }];
            if (usingV2 && mint) {
                lockupVaultFilter.push({
                    memcmp: {
                        offset: (0, __1.getLockupVaultMintOffsetV2)(),
                        bytes: mint.toBase58()
                    }
                });
            }
            const lockupVaultAccounts = yield context.connection.getProgramAccounts(context.program.programId, {
                filters: lockupVaultFilter,
            });
            if (lockupVaultAccounts.length === 0) {
                return [];
            }
            return (yield Promise.all(lockupVaultAccounts.map((info) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const lockupVaultInfo = fetcher.parseAccountData(usingV2, (_a = info === null || info === void 0 ? void 0 : info.account) === null || _a === void 0 ? void 0 : _a.data, fetcher_1.ParsableLockupVault);
                if (lockupVaultInfo) {
                    return {
                        lockupVault: info.pubkey.toBase58(),
                        bump: lockupVaultInfo.bump,
                        mint: usingV2 ? lockupVaultInfo.mint.toBase58() : mint,
                        index: lockupVaultInfo.index,
                        apy: lockupVaultInfo.apy,
                        lockupDuration: lockupVaultInfo.lockupDuration.toString(),
                        minStakeAmount: lockupVaultInfo.minStakeAmount.toString(),
                        totalRewardClaimed: lockupVaultInfo.totalRewardClaimed.toString(),
                    };
                }
                else {
                    return null;
                }
            }))));
        });
    }
    getAllUserLockupStakingAccount(user, usingV2, unlocked, mint) {
        return __awaiter(this, void 0, void 0, function* () {
            const context = usingV2 ? this.v2Ctx : this.ctx;
            const fetcher = new fetcher_1.AccountFetcher(context.connection);
            const filters = [
                { dataSize: usingV2 ? __1.LOCKUP_STAKING_ACCOUNT_LEN : __1.SOLCAT_LOCKUP_STAKING_ACCOUNT_LEN },
                {
                    memcmp: {
                        offset: usingV2
                            ? (0, __1.getLockupStakingAccountOwnerOffsetV2)()
                            : (0, __1.getLockupStakingAccountOwnerOffset)(),
                        bytes: user.toBase58()
                    }
                },
            ];
            if (unlocked !== undefined) {
                filters.push({
                    memcmp: {
                        offset: usingV2 ? (0, __1.getLockupStakingAccountUnlockedOffsetV2)() : (0, __1.getLockupStakingAccountUnlockedOffset)(),
                        bytes: unlocked ? "2" : "1",
                    },
                });
            }
            if (usingV2 && mint) {
                filters.push({
                    memcmp: {
                        offset: (0, __1.getLockupStakingAccountMintOffsetV2)(),
                        bytes: mint.toBase58()
                    }
                });
            }
            const lockupStakingAccounts = yield context.connection.getProgramAccounts(context.program.programId, { filters });
            if (lockupStakingAccounts.length === 0) {
                return [];
            }
            return (yield Promise.all(lockupStakingAccounts.map((info) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const lockupStakingAccountInfo = fetcher.parseAccountData(usingV2, (_a = info === null || info === void 0 ? void 0 : info.account) === null || _a === void 0 ? void 0 : _a.data, fetcher_1.ParsableLockupStakingAccount);
                if (lockupStakingAccountInfo) {
                    return {
                        bump: lockupStakingAccountInfo.bump,
                        index: lockupStakingAccountInfo.index,
                        lockupVault: lockupStakingAccountInfo.lockupVault,
                        committedApy: lockupStakingAccountInfo.committedApy,
                        lockedAmount: lockupStakingAccountInfo.lockedAmount,
                        lockedAt: lockupStakingAccountInfo.lockedAt,
                        unlocked: lockupStakingAccountInfo.unlocked,
                    };
                }
                else {
                    return null;
                }
            }))));
        });
    }
}
exports.StakingClient = StakingClient;
function getProtocolInfo(connection_1) {
    return __awaiter(this, arguments, void 0, function* (connection, usingV2 = false, mints) {
        if (usingV2 && (mints === null || mints === void 0 ? void 0 : mints.length) === 0) {
            throw new Error("Mints array is empty, please provide for V2 protocol");
        }
        const programId = usingV2 ? __1.STAKING_PROGRAM_ID_V2 : __1.SOLCAT_STAKING_PROGRAM_ID;
        const pda = new __1.PDA(programId);
        const fetcher = new fetcher_1.AccountFetcher(connection);
        const config = pda.config();
        const configData = yield fetcher.getConfig(config.key, true, usingV2);
        if (!configData) {
            throw new Error("Config account not found");
        }
        if (usingV2) {
            const flexibleVaults = mints.map(mint => pda.flexibleVaultV2(mint));
            let stakingInfo = {};
            yield Promise.all(flexibleVaults.map((flexibleVault) => __awaiter(this, void 0, void 0, function* () {
                const flexibleVaultInfo = (yield fetcher.getFlexibleVault(flexibleVault.key, true, usingV2));
                if (!flexibleVaultInfo) {
                    throw new Error("Flexible vault account not found");
                }
                const lockupVaultAccounts = yield connection.getProgramAccounts(programId, {
                    filters: [
                        {
                            dataSize: __1.LOCKUP_VAULT_LEN
                        },
                        {
                            memcmp: {
                                offset: (0, __1.getLockupVaultMintOffsetV2)(),
                                bytes: flexibleVaultInfo.mint.toBase58()
                            }
                        }
                    ],
                });
                if (lockupVaultAccounts.length === 0) {
                    throw new Error("Lockup vault account not found");
                }
                const lockupVaultsInfo = yield Promise.all(lockupVaultAccounts.map((info) => __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    const lockupVaultInfo = fetcher.parseAccountData(usingV2, (_a = info === null || info === void 0 ? void 0 : info.account) === null || _a === void 0 ? void 0 : _a.data, fetcher_1.ParsableLockupVault);
                    return lockupVaultInfo;
                })));
                // sort lockup vaults info by index
                lockupVaultsInfo.sort((a, b) => a.index - b.index);
                const totalFlexibleStaked = Number(BigInt(flexibleVaultInfo.totalSupply.toString()));
                const apr = calculateAPR(totalFlexibleStaked, Number(flexibleVaultInfo.rewardRate.toString()));
                stakingInfo[flexibleVaultInfo.mint.toBase58()] = Object.assign({ flexibleRewardRate: flexibleVaultInfo.rewardRate.toString(), flexibleApr: apr, flexibleWithdrawalDelayTime: flexibleVaultInfo.withdrawalDelayTime.toString() }, lockupVaultsInfo.reduce((acc, vault) => {
                    if (vault) {
                        acc.lockupApy.push(Number(vault.apy));
                        acc.lockupDuration.push(vault.lockupDuration.toString());
                        acc.minLockupAmount.push(vault.minStakeAmount.toString());
                    }
                    return acc;
                }, {
                    lockupApy: [],
                    lockupDuration: [],
                    minLockupAmount: [],
                }));
            })));
            return {
                admin: configData.admin.toBase58(),
                stakingInfo,
            };
        }
        else {
            const flexibleVault = pda.flexibleVault();
            const flexibleVaultInfo = yield fetcher.getFlexibleVault(flexibleVault.key, true, false);
            if (!flexibleVaultInfo) {
                throw new Error("Flexible vault account not found");
            }
            const lockupVaultAccounts = yield connection.getProgramAccounts(programId, {
                filters: [
                    {
                        dataSize: __1.SOLCAT_LOCKUP_VAULT_LEN
                    },
                ],
            });
            if (lockupVaultAccounts.length === 0) {
                throw new Error("Lockup vault account not found");
            }
            const lockupVaultsInfo = yield Promise.all(lockupVaultAccounts.map((info) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const lockupVaultInfo = fetcher.parseAccountData(false, (_a = info === null || info === void 0 ? void 0 : info.account) === null || _a === void 0 ? void 0 : _a.data, fetcher_1.ParsableLockupVault);
                return lockupVaultInfo;
            })));
            // sort lockup vaults info by index
            lockupVaultsInfo.sort((a, b) => a.index - b.index);
            const totalFlexibleStaked = Number(BigInt(flexibleVaultInfo.totalSupply.toString()));
            const apr = calculateAPR(totalFlexibleStaked, Number(flexibleVaultInfo.rewardRate.toString()));
            return Object.assign({ admin: configData.admin.toBase58(), mint: configData.mint.toBase58(), flexibleRewardRate: flexibleVaultInfo.rewardRate.toString(), flexibleApr: apr, flexibleWithdrawalDelayTime: flexibleVaultInfo.withdrawalDelayTime.toString(), totalFlexibleStaked: totalFlexibleStaked.toString(), totalFlexibleReward: flexibleVaultInfo.totalRewardClaimed.toString() }, lockupVaultsInfo.reduce((acc, vault) => {
                if (vault) {
                    acc.lockupApy.push(Number(vault.apy));
                    acc.lockupDuration.push(vault.lockupDuration.toString());
                    acc.minLockupAmount.push(vault.minStakeAmount.toString());
                    acc.totalLockupStaked.push(vault.totalLockedAmount.toString());
                    acc.totalLockupReward.push(vault.totalRewardClaimed.toString());
                }
                return acc;
            }, {
                lockupApy: [],
                lockupDuration: [],
                minLockupAmount: [],
                totalLockupStaked: [],
                totalLockupReward: [],
            }));
        }
    });
}
function calculateAPR(totalStaked, rewardPerSecond) {
    if (totalStaked === 0)
        return 0;
    const secondsInYear = 365 * 24 * 60 * 60;
    const annualReward = rewardPerSecond * secondsInYear;
    const apr = (annualReward / totalStaked) * 100;
    return apr;
}
